// extracted by mini-css-extract-plugin
module.exports = {"starsRow":"StarsRow__starsRow__8ifDr","star":"StarsRow__star__Zu5w1","grayRow":"StarsRow__grayRow__Z9zJI","goldRow":"StarsRow__goldRow__SrT8V"};